import AddIcon from '@mui/icons-material/Add';
import CancelIcon from '@mui/icons-material/Cancel';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import React, { useState } from 'react';
import {
  required,
  Button,
  SaveButton,
  TextInput,
  useCreate,
  useNotify,
  Form,
  CreateBase,
} from 'react-admin';
import { useFormContext } from 'react-hook-form';

function AutorRapido({ onChange }) {
  const [showDialog, setShowDialog] = useState(false);
  const [create, { isLoading }] = useCreate('blog_authors');
  const notify = useNotify();
  const { setValue } = useFormContext();

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async (values) => {
    create(
      'blog_authors',
      { data: values },
      {
        onSuccess: (data) => {
          setValue('author', data.id);
          onChange(data);
          setShowDialog(false);
        },
        onError: () => {
          notify('Já existe um Autor com esse nome!', 'warning');
        },
      },
    );
  };

  return (
    <>
      <Button
        onClick={handleClick}
        label="ra.action.create"
        variant="outlined"
        style={{ marginBottom: '10px' }}
      >
        <AddIcon />
      </Button>
      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label="Criar Autor"
      >
        <DialogTitle>Criar Autor</DialogTitle>
        <CreateBase resource="blog_authors" id="blog_authors" redirect={false}>
          <Form onSubmit={handleSubmit}>
            <DialogContent>
              <TextInput
                label="Nome"
                source="name"
                validate={required()}
                fullWidth
              />
            </DialogContent>
            <DialogActions>
              <Button
                label="ra.action.cancel"
                onClick={handleCloseClick}
                disabled={isLoading}
              >
                <CancelIcon />
              </Button>
              <SaveButton disabled={isLoading} />
            </DialogActions>
          </Form>
        </CreateBase>
      </Dialog>
    </>
  );
}

export default AutorRapido;
